
import { Component, Vue, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';

import {
    dataAnalysisSalesAmountStats
} from '@/api/toBApi';
import {
    productCategory
} from '@/api/supplier';
import {
    ownBrandProductfilterBoxList
} from '@/api/order';

import {
    getSearchDate,
    nextDay
} from "@/utils/index"

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate,
        'slz-dialog': Dialog,
    }
})
export default class LeaderProductPromotionStats extends Vue {

    private list = [];
    private pageNo = 1;
    private pageSize = 20;
    private total = 0;
    private loading = false;

    private searchParams = {
        StatsType: 0, //0：个人零售带货 1：团队带货业绩,
        Keywords: '',
        RoleGrade: 1,
        StartTime: '',
        EndTime: '',
        ProductType: 0, //0：全部商品 1：专区商品 2：单品,
        RelationId: 0, //ProductType=专区商品时的分类Id ， ProductType=单品时的自营品牌商品Id,
        SuperId: '',
        Skip: 0,
        Take: 20
    }
    private paramsCopy: any = {};
    private filterTimeCopy = '';

    private searchStatsType = 0;
    private showBtns = false;

    private filterTime = [getSearchDate(2)[0], getSearchDate(2)[0]].join('/');

    private roleGradeList = [
        { value: null, label: '全部' },
        { value: 1, label: '联创' },
        { value: 2, label: '核心' },
        { value: 3, label: '总代' }
    ]
    private categoryList = [];
    private productList = [];

    @Watch('searchParams.ProductType')
    private ProductTypeChange() {
        if (this.searchParams.ProductType === 1) {
            this.searchParams.RelationId = this.categoryList[0]?.Id;
        } else if (this.searchParams.ProductType === 2) {
            this.searchParams.RelationId = this.productList[0]?.Id;
        } else {
            this.searchParams.RelationId = 0;
        }
    }

    private mounted() {
        this.doSearch();
        this.getCategoryList();
        this.getProductList();
    }

    private doSearch() {
        this.pageNo = 1
        this.getList()
    }
    private changePage(e) {
        this.pageNo = e
        this.getList()
    }
    private async getList() {
        this.loading = true;
        try {

            this.searchParams.Skip = (this.pageNo - 1) * this.pageSize;
            this.searchParams.Take = this.pageSize;
            this.searchParams.Keywords = this.searchParams.Keywords.trim();

            if (this.filterTime) {
                this.searchParams.StartTime = this.filterTime.split('/')[0];
                this.searchParams.EndTime = nextDay(this.filterTime.split('/')[1], 1);
            }
            
            const res: any = await dataAnalysisSalesAmountStats(this.searchParams);
            this.list = res.Result.Results;
            this.total = res.Result.Total;

            let suppers = this.list.filter(item => {
                return item.RoleGrade !== 3;
            })

            this.showBtns = suppers.length > 0;

            this.searchStatsType = this.searchParams.StatsType;

            this.paramsCopy = JSON.parse(JSON.stringify(this.searchParams));
            this.filterTimeCopy = this.filterTime;

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

    private async getCategoryList() {
        try {
            const res: any = await productCategory({
                Skip: 0,
                Take: 99999,
                IsJoinZoneRank: true
            });
            this.categoryList = res.Result.Results;

        } catch (error) {

        }
    }

    private async getProductList() {
        try {
            const res: any = await ownBrandProductfilterBoxList({});
            this.productList = res.Result;
        } catch (error) {
        }
    }

    private handleView(record) {
        let router: any = this.$router;
        router.push({
            name: 'subProductPromotionStats',
            query: {
                StatsType: this.paramsCopy.StatsType,
                ProductType: this.paramsCopy.ProductType,
                RelationId: this.paramsCopy.RelationId,
                filterTime: this.filterTimeCopy,
                SuperId: record.MemberId,
                name: record.Name,
                phone: record.Phone
            }
        })
    }

    private handleExport(){

        console.log(this.paramsCopy)

        // let query:any = {
        //     StatsType: this.paramsCopy.StatsType,
        //     Keywords: this.paramsCopy.Keywords.trim(),
        //     RoleGrade: this.paramsCopy.RoleGrade || '',
        //     ProductType: this.paramsCopy.ProductType,
        //     RelationId: this.paramsCopy.RelationId,
        //     StartTime: this.paramsCopy,
        //     EndTime
        // }

        // if (this.filterTime) {
        //     query.StartTime = this.filterTime.split('/')[0];
        //     query.EndTime = nextDay(this.filterTime.split('/')[1], 1);
        // }

        let query = JSON.parse(JSON.stringify(this.paramsCopy));

        query.RoleGrade = query.RoleGrade || '';
        query.RelationId = query.RelationId || '';


        window.open(`${location.origin}/pc/dataAnalysis/salesAmountStatsExport?${new URLSearchParams(query).toString()}`)
    }

}
